import { required } from "vuelidate/lib/validators";

export default class InformacoesData {
  validade = null;
  status = null;
  observacao = '';
  pesoBruto = 0;
  pesoLiquido = 0;
  constructor(
    validade = null,
    status = null,
    observacao = '',
    pesoBruto = 0,
    pesoLiquido = 0,
  ) {
    this.validade = validade;
    this.status = status;
    this.observacao = observacao;
    this.pesoBruto = pesoBruto;
    this.pesoLiquido = pesoLiquido;
  }
}

export const InformacoesDataRequired = {
  validade: {
    required,
  },
  status: {
    required,
  },
  observacao: {
    required,
  },
};
